import React from 'react';
import CargaTarjeta from '../../comun/CargaTarjeta';

/**
 * Tarjeta «Intereses bancarios» del AT 2026: el Excel «Detalle_DJ_1890» que el SII
 * entrega a la persona en Información de terceros. Su lector está en
 * src/services/declaracionRenta/empresarioIndividual/2026/intereses/lector.js
 */
const COLUMNAS = [
  { campo: 'nombre_declarante', titulo: 'Institución' },
  { campo: 'rut_declarante', titulo: 'RUT institución' },
  { campo: 'depositos_positivo', titulo: 'Depósitos (+)', monto: true },
  { campo: 'depositos_negativo', titulo: 'Depósitos (−)', monto: true },
  { campo: 'cuentas_corrientes_positivo', titulo: 'Cuentas corrientes (+)', monto: true },
  { campo: 'cuentas_corrientes_negativo', titulo: 'Cuentas corrientes (−)', monto: true },
  { campo: 'captacion_positivo', titulo: 'Captación (+)', monto: true },
  { campo: 'captacion_negativo', titulo: 'Captación (−)', monto: true },
  { campo: 'numero_certificado', titulo: 'N° certificado' },
  { campo: 'estado_sii', titulo: 'Estado SII' },
];

const InteresesPage = ({ anioTributario, idCompany }) => (
  <CargaTarjeta
    anioTributario={anioTributario}
    idCompany={idCompany}
    tarjeta="intereses"
    columnas={COLUMNAS}
    extensiones=".xls,.xlsx"
    ayuda={(
      <>
        Sube el Excel <strong>Detalle_DJ_1890_{anioTributario}00_&lt;RUT&gt;.xlsx</strong> que descargas del SII en
        Información de terceros: los intereses reales actualizados que informó cada banco o institución, positivos y
        negativos. El archivo no se guarda.
      </>
    )}
  />
);

export default InteresesPage;
